import { IDashboardConfig } from '@/store/models/dashboard-config.model';

export function getHosts(config: IDashboardConfig) {
  const hostParts = window.location.host.split('.');

  const hosts = [
    `${config?.api?.baseUrl}/`,
    `${config?.api?.webhooks?.path}/`,
    `${window.location.host}/`,
    `///`,
  ].filter((host) => typeof host === 'string');

  /* Dev or Sandbox */
  if (hostParts.length === 4) {
    const environment = hostParts[1];

    const host = hostParts[0].split('-');

    const [, clientNamePart, ...suffixClient] = host;
    const clientName = suffixClient.length > 0 ? `${clientNamePart}-${suffixClient.join('-')}` : clientNamePart;

    hosts.push(`https://${clientName}.${environment}.treezor.co/`);
  } else {
    /* prod */
    const clientName = hostParts[1];
    hosts.push(`https://${clientName}.api.treezor.co/`);
  }

  return hosts;
}
